import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';

import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { getPurchaseProtectionUrl } from '@/utils/urls';

export const PurchaseProtectionPageMeta = () => {
    const baseUrl = useAppSelector((state) => getBaseUrl(state));
    const canonical = baseUrl + getPurchaseProtectionUrl();

    return (
        <PageHeaderMeta
            canonical={canonical}
            title="Purchase Protection"
        >
            <meta
                content="noindex, nofollow"
                name="robots"
            />
        </PageHeaderMeta>
    );
};
